module.exports = __webpack_public_path__ + "static/media/EnglishFont.be89a5be.ttf";